import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';
import {
    CodeBlock,
    BlockType,
    SettingType,
    SettingState,
    Setting,
    ValidationMessage,
    ValidationMessageType,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';

export default class Tibbit_43 extends BaseTibbit {
    constructor() {
        super();
        this.id = 'tibbit_43_1';
        this.name = 'Tibbit 43';
        this.files = [
            'libraries/tibbits/tbt43/tibbit43.tbh',
            'libraries/tibbits/tbt43/tibbit43.tbs',
        ];
        const settings: Setting[] = [
            {
                id: 'GENERAL',
                name: 'Configuration',
                settingType: SettingType.GROUP,
                default: '',
                required: true,
            },
            {
                id: 'ADVANCED',
                name: 'Advanced',
                settingType: SettingType.GROUP,
                default: '',
                required: true,
            },
            {
                id: 'FIRMWARE',
                name: 'Firmware Upload',
                settingType: SettingType.GROUP,
                default: '',
            },
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.NAME,
                group: 'GENERAL',
                default: '',
                required: true,
            },
            {
                id: 'CH1NAME',
                name: 'Channel 1 Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.FLOAT,
                required: true,
                group: 'GENERAL',
                default: '',
            },
            {
                id: 'CH2NAME',
                name: 'Channel 2 Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.FLOAT,
                required: true,
                group: 'GENERAL',
                default: '',
            },
            {
                id: 'CH3NAME',
                name: 'Channel 3 Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.FLOAT,
                required: true,
                group: 'GENERAL',
                default: '',
            },
            {
                id: 'CH4NAME',
                name: 'Channel 4 Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.FLOAT,
                required: true,
                group: 'GENERAL',
                default: '',
            },
            {
                id: 'STORAGE',
                name: 'Storage',
                settingType: SettingType.OPTION,
                required: true,
                group: 'ADVANCED',
                default: 'MANUAL',
                options: [
                    {
                        name: "Don't Save to EEPROM",
                        value: 'MANUAL',
                    },
                    {
                        name: 'Save to EEPROM',
                        value: 'TO_EEPROM',
                    },
                ],
            },
            {
                id: 'MODE',
                name: 'Mode',
                settingType: SettingType.OPTION,
                required: true,
                group: 'ADVANCED',
                default: 'COMMAND_MODE',
                options: [
                    {
                        name: 'Command Mode',
                        value: 'COMMAND_MODE',
                    },
                    {
                        name: 'Data Mode',
                        value: 'DATA_MODE',
                    },
                ],
            },
            {
                id: 'FORMAT_DATA',
                name: 'Data Format',
                settingType: SettingType.OPTION,
                required: true,
                group: 'ADVANCED',
                default: 'DATA_ASCII',
                options: [
                    {
                        name: 'ASCII',
                        value: 'DATA_ASCII',
                    },
                    {
                        name: 'Binary',
                        value: 'DATA_BIN',
                    },
                    {
                        name: 'Hex',
                        value: 'DATA_HEX',
                    },
                ],
            },
            {
                id: 'FORMAT_COMMAND',
                name: 'Data Format',
                settingType: SettingType.OPTION,
                required: true,
                group: 'ADVANCED',
                default: 'DATA_ASCII',
                options: [
                    {
                        name: 'ASCII',
                        value: 'DATA_ASCII',
                    },
                    {
                        name: 'Hex',
                        value: 'DATA_HEX',
                    },
                ],
            },
            {
                id: 'SAMPLING',
                name: 'Sampling Mode',
                settingType: SettingType.OPTION,
                required: true,
                group: 'ADVANCED',
                default: 'SAMPLING_SINGLE',
                options: [
                    {
                        name: 'Single-Ended',
                        value: 'SAMPLING_SINGLE',
                    },
                    {
                        name: 'Differential',
                        value: 'SAMPLING_DIFF',
                    },
                ],
            },
            {
                id: 'RATE',
                name: 'Sample Rate',
                settingType: SettingType.NUMBER,
                required: true,
                group: 'ADVANCED',
                default: '1',
                value: '1',
                min: 1,
                max: 1000,
            },
            {
                id: 'RX_BUF',
                name: 'RX Buffer Size',
                settingType: SettingType.NUMBER,
                required: true,
                group: 'ADVANCED',
                default: '32',
                value: '32',
                min: 1,
                max: 1000,
            },
            {
                id: 'CHANNELS_SINGLE',
                name: 'Enabled Data Mode Channels',
                settingType: SettingType.MULTISELECT,
                required: true,
                group: 'ADVANCED',
                default: '1,2,3,4',
                options: [
                    {
                        name: 'Channel 1 (IO1 - GND)',
                        value: '1',
                    },
                    {
                        name: 'Channel 2 (IO2 - GND)',
                        value: '2',
                    },
                    {
                        name: 'Channel 3 (IO3 - GND)',
                        value: '3',
                    },
                    {
                        name: 'Channel 4 (IO4 - GND)',
                        value: '4',
                    },
                ],
            },
            {
                id: 'CHANNELS_DIFF',
                name: 'Enabled Data Mode Channels',
                settingType: SettingType.MULTISELECT,
                required: true,
                group: 'ADVANCED',
                default: '1,2',
                options: [
                    {
                        name: 'Channel 1 (IO1 - IO2)',
                        value: '1',
                    },
                    {
                        name: 'Channel 2 (IO3 - IO4)',
                        value: '2',
                    },
                ],
            },
            {
                id: 'FIRMWAREFILE',
                name: 'Firmware to Upload',
                helpText: `The Tibbit is calibrated at the factory for precision. 
                Before upgrading the firmware of your Tibbit, make sure to copy the values of the
                three calibration parameters (SA, SB, and SN); you will need to set them after completing the update.`,
                settingType: SettingType.FILE,
                required: true,
                group: 'FIRMWARE',
                default: '',
                max: 102400,
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getState(settingId: string): SettingState {
        const FIRMWAREFILE = this.getSettingValue('FIRMWAREFILE');
        if (FIRMWAREFILE !== '') {
            if (settingId !== 'FIRMWARE' && settingId !== 'FIRMWAREFILE') {
                return SettingState.HIDDEN;
            }
        }

        if (this.getSettingValue('MODE').toString() === 'COMMAND_MODE') {
            switch (settingId) {
                case 'RATE':
                case 'CHANNELS_SINGLE':
                case 'CHANNELS_DIFF':
                case 'FORMAT_DATA':
                    return SettingState.HIDDEN;
                default:
                    return SettingState.ENABLED;
            }
        } else if (settingId === 'FORMAT_COMMAND' && this.getSettingValue('MODE').toString() === 'DATA_MODE') {
            return SettingState.HIDDEN;
        } else if (settingId === 'CHANNELS_SINGLE' && this.getSettingValue('SAMPLING').toString() === 'SAMPLING_DIFF') {
            return SettingState.HIDDEN;
        } else if (settingId === 'CHANNELS_DIFF' && this.getSettingValue('SAMPLING').toString() === 'SAMPLING_SINGLE') {
            return SettingState.HIDDEN;
        }
        return SettingState.ENABLED;
    }


    getFiles() {
        const FIRMWAREFILE = this.getSettingValue('FIRMWAREFILE');
        const fileArray = [];
        if (FIRMWAREFILE !== '') {
            fileArray.push('libraries/pic/PIC_LVP.tbh');
            fileArray.push('libraries/pic/PIC_LVP.tbs');
            fileArray.push(FIRMWAREFILE.split('\n')[0]);
        }
        return this.files.concat(fileArray);
    }

    validate(): Array<ValidationMessage> {
        const errors: Array<ValidationMessage> = [];
        const project: ProjectConfiguration = this.project;
        const tibbit_43_1_node = project.getFeature('node_tibbit_43_1') as BaseNode;
        if (tibbit_43_1_node !== undefined) {
            if (this.getSettingValue('MODE').toString() !== 'COMMAND_MODE') {
                errors.push({ message: 'Data Mode not supported by AppBlocks', messageType: ValidationMessageType.ERROR });
            }
        }
        const tibbit_43_2_node = project.getFeature('node_tibbit_43_2') as BaseNode;
        if (tibbit_43_2_node !== undefined) {
            if (this.getSettingValue('MODE').toString() !== 'COMMAND_MODE') {
                errors.push({ message: 'Data Mode not supported by AppBlocks', messageType: ValidationMessageType.ERROR });
            }
        }
        return errors;
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];

        if (this.project.runtime === 'simulator') {
            return [];
        }

        const FIRMWAREFILE = this.getSettingValue('FIRMWAREFILE');
        const MODE = this.getSettingValue('MODE');
        const SAMPLING = this.getSettingValue('SAMPLING');
        let CHANNELS = SAMPLING === 'SAMPLING_DIFF' ? this.getSettingValue('CHANNELS_DIFF') : this.getSettingValue('CHANNELS_SINGLE');
        CHANNELS = CHANNELS.split(',').sort().join(',');
        const SOCKET = `S${this.getSettingValue('SOCKET')}_TBT43`;
        const STORAGE = this.getSettingValue('STORAGE').toString();
        let initCode;
        let samplingCompletedCallback;
        let format;
        let queryFormat = 'ascii';
        if (this.getSettingValue('MODE').toString() === 'COMMAND_MODE') {
            format = this.getSettingValue('FORMAT_COMMAND');
        } else {
            format = this.getSettingValue('FORMAT_DATA');
        }

        if (FIRMWAREFILE !== '') {
            const pins = Tibbits.getSocketPins(this.getSettingValue('SOCKET'), this.project.device.id);
            const fileName = FIRMWAREFILE.split('\n')[0];
            blocks.push({
                location: 'boot',
                blockType: BlockType.CODE,
                template: `
    pic_lvp_start(${pins[0]},${pins[1]}, ${pins[3]})
    sys.debugprint("Programming PIC coprocessor with new firmware.\\r\\n")
    sys.debugprint("Please be patient. This can take a while.\\r\\n")
    if not pic_lvp_upload_firmware("${fileName}") then
        sys.debugprint("Error: Could not upload firmware.\\r\\n")
        sys.halt()
    end if`,
            });
            return blocks;
        }


        if (format === 'DATA_ASCII') {
            queryFormat = 'ascii';
            samplingCompletedCallback = `
    dim sample_count, channel as byte
    for channel=0 to len(TIBBIT43_SETTINGS_LIST(ser.num).channels)-1
        dim count as float
        for sample_count=0 to TIBBIT_43_NO_OF_SAMPLES-1
            count=count+strtof(samples(sample_count).value(channel))
        next sample_count
        count=count/TIBBIT_43_NO_OF_SAMPLES
        dim channel_num as string=mid(TIBBIT43_SETTINGS_LIST(ser.num).channels,channel+1,1)
        sys.debugprint("Average value for channel " + channel_num + ": " + ftostr(count,FTOSTR_MODE_PLAIN,5)+"\\r\\n")
        count=0
    next channel
            `;
        } else {
            queryFormat = 'hex';
            samplingCompletedCallback = `
    'The variable "samples" contains an array of all of the samples collected.`;
        }
        switch (STORAGE) {
            case 'MANUAL':
                initCode = `tibbit_43_set_data_format(${SOCKET},${format})
    tibbit_43_set_sampling_mode(${SOCKET},${SAMPLING})
    tibbit_43_set_sample_rate(${SOCKET},${this.getSettingValue('RATE')})
    tibbit_43_set_enable_channels(${SOCKET},"${CHANNELS}")`;
                break;
            case 'TO_EEPROM':
                initCode = `tibbit_43_set_data_format(${SOCKET},${format})
    tibbit_43_set_sampling_mode(${SOCKET},${SAMPLING})
    tibbit_43_set_sample_rate(${SOCKET},${this.getSettingValue('RATE')})
    tibbit_43_set_enable_channels(${SOCKET},"${CHANNELS}")
    tibbit_43_store_settings_to_EEPROM(${SOCKET})`;
                break;
            default:
                break;
        }
        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
    tibbit_43_init(${SOCKET})
    ${initCode}
    tibbit_43_set_mode(${SOCKET},${MODE})
    `,
        });
        blocks.push({
            location: 'GLOBAL_DEFINES',
            blockType: BlockType.CODE,
            template: `
#define TIBBIT_43_RX_BUF ${this.getSettingValue('RX_BUF')}
    `,
        });


        blocks.push({
            location: 'GLOBAL_CONSTS',
            blockType: BlockType.CODE,
            template: `
const ${SOCKET} = ${Tibbits.getSocket(this.getSettingValue('SOCKET'), this.project.device.id)?.serial}`,
        });

        blocks.push({
            location: 'DEVICE_TBS',
            blockType: BlockType.LOCATION,
            id: 'callback_tibbit_43_data_arrival',
            template: `
sub callback_tibbit_43_data_arrival(mode as string(12), port as byte, channel1 as string(10), channel2 as string(10), channel3 as string(10), channel4 as string(10))
    '****callback_tibbit_43_data_arrival****'
    'sys.debugprint("Mode:" + mode + "\\tPort: " + str(port) + "\\tValues: " + channel1 + ", " + channel2 + ", " + channel3 + ", " + channel4 + ".\\r\\n")
end sub       
`,
        });

        blocks.push({
            location: 'DEVICE_TBS',
            blockType: BlockType.LOCATION,
            id: 'callback_tibbit_43_sampling_completed',
            template: `
sub callback_tibbit_43_sampling_completed(samples as TIBBIT43_VALUES(TIBBIT_43_NO_OF_SAMPLES))
    '****callback_tibbit_43_sampling_completed****'
end sub
`,
        });

        blocks.push({
            location: 'on_ser_data_arrival',
            blockType: BlockType.CODE,
            id: 'tibbit_43_proc_data',
            template: `
    tibbit_43_proc_data()`,
        });


        for (let i = 0; i < 4; i++) {
            const varName = this.getSettingValue(`CH${i + 1}NAME`);
            let channelNum = (i + 1).toString();
            if (SAMPLING === 'SAMPLING_DIFF') {
                if (i === 2) {
                    channelNum = '2';
                }
            }
            blocks.push({
                location: `var_${varName}_update`,
                blockType: BlockType.CODE,
                template: `
    var_${varName}_update_completed(tibbit_43_get_data_${queryFormat}(${SOCKET},"${channelNum}"))
    `,
            });
        }

        return blocks;
    }
}
